/*=========================================================================================
  File Name: gettes.js
  Description: Favorite Items Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

export default {
  isFavouriteItem: (state) => (itemId) => {
    return (state.favouriteItems.includes(itemId));
  },
  favouriteItems: (state, getters, rootState) => {
    let newArray = [];
    rootState.menus.currentMenu.menuItems.forEach(item => {
      state.favouriteItems.forEach(itemId => {
        if (item.itemId === itemId) {
          newArray.push(item);
        }
      })
    });
    return newArray;
  }
}
